import { render, staticRenderFns } from "./InnoSupport.vue?vue&type=template&id=1c518984"
import script from "./InnoSupport.vue?vue&type=script&lang=js"
export * from "./InnoSupport.vue?vue&type=script&lang=js"
import style0 from "./InnoSupport.vue?vue&type=style&index=0&id=1c518984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports